import { useTranslation } from "next-i18next";
import Image from "next/image";
import Link from "next/link";
import { FC } from "react";
import Button from "~/components/Button";
import { Container } from "~/components/Container";
import Text from "~/components/Text";
import Colors from "~/constants/colors";
import useUtmParams from "~/hooks/useUtmParams";
import Trans from "~/types/translationKeys";
import styles from "./ReferralCTA.module.scss";

const ReferralCTA: FC = () => {
  const { t } = useTranslation();
  const utmParams = useUtmParams();

  return (
    <section id="cta" className={styles.cta}>
      <Container className={styles.cta_container}>
        <div className={styles.left} data-aos="fade-up">
          <Text
            type="headline-4"
            color={Colors.GREY_00}
            className="!leading-normal"
          >
            {t(Trans.ready_to_get_started)}
          </Text>

          <Text
            type="title-3"
            color={Colors.GREY_50}
            className="!leading-normal"
          >
            {t(Trans.join_the_cx_genie_referral_program_today)}
          </Text>

          <Text
            type="title-3"
            color={Colors.GREY_50}
            className="!leading-normal"
          >
            {t(Trans.start_earning_while_benefitting_from_the_platform)}
          </Text>

          <div>
            <Link
              type="outline"
              href={{
                pathname: `${process.env.NEXT_PUBLIC_DASHBOARD_URL}/sign-in`,
                query: { ...utmParams },
              }}
              target="_blank"
            >
              <Button variant="secondary" className={styles.button}>
                {t(Trans.start_earning_now)}
              </Button>
            </Link>
          </div>
        </div>
        <div className={styles.right}>
          <Image
            src="/svgs/referral_CTA.svg"
            alt="CTA"
            width={382}
            height={382}
            className="object-contain"
          />
        </div>
      </Container>
    </section>
  );
};

export default ReferralCTA;
